export default function fetchSharedContentSuccess(state, payload) {
  const {
    next,
    prev,
    shares: sharedContent,
  } = payload;
  return {
    ...state,
    next,
    prev,
    sharedContent,
  };
}